import React from 'react';

const LiveAuctionSkeleton = () => {

  return <div className={'auction-wrapper-skeleton'}>
    <h2 className={'title'}/>

    <div className={'auctions'}>
      <div className={'auction'}>
        <div className="header">
          <div className="time-left"/>
          <div className="right">
            <div className="views"/>
            <img alt='' className="eye-icon"/>
          </div>
        </div>
        <div className="content">
          <div  className={'img'} />
          <div className="description"/>
          <div className="current-bid"/>
        </div>
      </div>
      <div className={'auction'}>
        <div className="header">
          <div className="time-left"/>
          <div className="right">
            <div className="views"/>
            <img alt='' className="eye-icon"/>
          </div>
        </div>
        <div className="content">
          <img alt=""/>
          <div className="description"/>
          <div className="current-bid"/>
        </div>
      </div>
    </div>
  </div>

};

export default LiveAuctionSkeleton;


